<template>
<div class="upgrade-checkout-page">
    <div v-if="loading" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>
    <!-- Navigation -->
    <section id="navtest" class="nav nscrtest">
        <div class="promo-div">
            <div class="promo-box">
                <div class="text-block-775">
                    <span class="text-span-181">LIMITED TIME: </span>FREE OVERNIGHT SHIPPING &amp; DOCTOR REVIEW
                </div>
            </div>
        </div>
        <div class="nav-holder-div">
            <div class="nav-bar-div weight hide-block w-clearfix">
                <router-link to="/" class="brand w-nav-brand">
                    <img sizes="(max-width: 479px) 98vw, (max-width: 767px) 99vw, (max-width: 1000px) 100vw, 1000px" srcset="/images/NewSelf_Logo-p-500.png 500w, /images/NewSelf_Logo-p-800.png 800w, /images/NewSelf_Logo.webp 1000w" alt="" src="/images/NewSelf_Logo.webp" loading="lazy" class="nav-logo">
                </router-link>
                <div class="div-block-1714">
                    <a href="#" class="link-block-51 w-inline-block"></a>
                    <a href="#" class="link-block-68 w-inline-block">
                        <img loading="lazy" src="/images/icon_-cart.svg" alt="" class="image-422">
                        <div class="div-block-1788">
                            <div class="text-block-859">1</div>
                        </div>
                    </a>
                </div>
            </div>
            <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="navbar-3 w-nav">
                <router-link to="/" class="brand-4 w-nav-brand">
                    <img sizes="(max-width: 479px) 98vw, (max-width: 767px) 99vw, (max-width: 1000px) 100vw, 1000px" srcset="/images/NewSelf_Logo-p-500.png 500w, /images/NewSelf_Logo-p-800.png 800w, /images/NewSelf_Logo.webp 1000w" alt="" src="/images/NewSelf_Logo.webp" loading="lazy" class="nav-logo weight">
                </router-link>
                <nav role="navigation" class="nav-menu-4 w-nav-menu" :class="{ 'w--nav-menu-open': mobileMenuOpen }">
                    <a href="https://join.newself.com/" class="button-158 w-button">Get Started</a>
                </nav>
                <div class="menu-button-4 w-nav-button" :class="{ 'w--open': mobileMenuOpen }" @click="mobileMenuOpen = !mobileMenuOpen">
                    <div class="icon-42 w-icon-nav-menu"></div>
                </div>
            </div>
        </div>
    </section>

    <!-- Main Offer Section -->
    <section class="section_offer">
        <div class="offer_wrap-copy">
            <div class="upgrade_maindiv">
                <div class="offer-header-div hide">
                    <div class="flow-inclusions-header">Lose More Weight Faster. Pay Less.</div>
                    <div class="text-block-1713">The NewSelf Weight Loss Protocol is more than just medication, it is a full health optimization system to help you live better...longer.</div>
                </div>
                <div class="upgrade_flexdiv" v-if="active_el==1">
                    <div class="offer-flex-left hide">
                        <div class="offer_inclusions-box">
                            <div class="text-block-1705-copy">What's included</div>
                            <div class="offer_inclusions-div">
                                <div class="inclusion-entry-div">
                                    <div class="inclusions-left-div">
                                        <div class="inclusion-img-div">
                                            <img src="/images/Semaglutide-Vial_1.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="/images/Semaglutide-Vial_1-p-500.webp 500w, /images/Semaglutide-Vial_1-p-800.webp 800w, /images/Semaglutide-Vial_1.webp 1080w" alt="">
                                        </div>
                                        <div class="inclusions-text-div product">
                                            <div class="text-block-1706">3 Months Semaglutide+</div>
                                            <p class="inclusions-subs">Personalized Compounded GLP Medication - Subcutaneous</p>
                                        </div>
                                    </div>
                                    <div class="inclusions-right-div">
                                        <div class="div-block-2249 top-float"></div>
                                        <div class="text-block-1708">Included</div>
                                    </div>
                                </div>
                                <div class="row-divider offer"></div>
                                <div class="inclusion-entry-div">
                                    <div class="inclusions-left-div">
                                        <div class="inclusion-img-div">
                                            <img src="/images/icon_stetoscope.webp" loading="lazy" alt="" class="image-681">
                                        </div>
                                        <div class="inclusions-text-div">
                                            <div class="text-block-1706">Doctor Review &amp; Prescription</div>
                                            <p class="inclusions-subs">A doctor will review your intake, and prescribe Semaglutide+ (if appropriate) today!</p>
                                        </div>
                                    </div>
                                    <div class="inclusions-right-div">
                                        <div class="text-block-1708">Included</div>
                                    </div>
                                </div>
                                <div class="row-divider offer"></div>
                                <div class="inclusion-entry-div">
                                    <div class="inclusions-left-div">
                                        <div class="inclusion-img-div">
                                            <img src="/images/Doctor_newself.webp" loading="lazy" sizes="(max-width: 755px) 100vw, 755px" srcset="/images/Doctor_newself-p-500.webp 500w, /images/Doctor_newself.webp 755w" alt="" class="image-682">
                                        </div>
                                        <div class="inclusions-text-div">
                                            <div class="text-block-1706">1:1 Medical Support</div>
                                            <p class="inclusions-subs">24/7 access to our case team and licensed clinicians.</p>
                                        </div>
                                    </div>
                                    <div class="inclusions-right-div">
                                        <div class="text-block-1708">Included</div>
                                    </div>
                                </div>
                                <div class="row-divider offer"></div>
                                <div class="inclusion-entry-div">
                                    <div class="inclusions-left-div">
                                        <div class="inclusion-img-div">
                                            <img src="/images/icon_van.webp" loading="lazy" alt="" class="image-683">
                                        </div>
                                        <div class="inclusions-text-div">
                                            <div class="text-block-1706">Overnight Cold Shipping</div>
                                            <p class="inclusions-subs">We ship all medications <strong>next-day on cold packs</strong> to keep them stable and effective.</p>
                                        </div>
                                    </div>
                                    <div class="inclusions-right-div">
                                        <div class="text-block-1708">Included</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="upgrade-flex-div">
                        <div class="text-block-1739-copy">Extend Your Access. Lock In Our Low Pricing - Forever.</div>
                        <div class="text-block-1807">Renew now to avoid any interruption.</div>
                        <div class="glp-quiz-footer-div-copy-copy">
                            <div class="inclusion-boxes-div-copy">
                                <div class="inclusion-box hilite">
                                    <div class="inc-flex">
                                        <div class="box-icon-div">
                                            <img src="/images/icon_-RX-black.svg" loading="lazy" alt="">
                                        </div>
                                        <div class="inc-text-div full">
                                            <div class="text-block-1800">All Dosages the Same Low Price</div>
                                            <div class="text-block-1801">We don't charge you based on dosage changes</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="inclusion-box">
                                    <div class="inc-flex">
                                        <div class="box-icon-div">
                                            <img src="/images/icon_doc.svg" loading="lazy" alt="">
                                        </div>
                                        <div class="inc-text-div">
                                            <div class="text-block-1800">Doctor Support <span class="text-span-450">with<br>Health Concierge</span></div>
                                        </div>
                                        <div class="inc-price-text-div">
                                            <div class="text-block-1800-copy"><span class="text-span-449">$99</span> FREE</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="inclusion-box">
                                    <div class="inc-flex">
                                        <div class="box-icon-div">
                                            <img src="/images/icon_shipping.svg" loading="lazy" alt="">
                                        </div>
                                        <div class="inc-text-div">
                                            <div class="text-block-1800"><span class="text-span-450">Express</span> Shipping</div>
                                        </div>
                                        <div class="inc-price-text-div">
                                            <div class="text-block-1800-copy"><span class="text-span-449">$99</span> FREE</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="inclusion-box">
                                    <div class="inc-flex">
                                        <div class="box-icon-div">
                                            <img src="/images/icon_nopay_blk.svg" loading="lazy" alt="" class="no-pay">
                                        </div>
                                        <div class="inc-text-div">
                                            <div class="text-block-1800">Never Pay <span class="text-span-450">Monthly<br>Membership or App Fees</span></div>
                                        </div>
                                        <div class="inc-price-text-div">
                                            <div class="text-block-1800-copy"><span class="text-span-449">$99</span> FREE</div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="tp-rating-div">
                                        <div class="div-block-2309">
                                            <div class="trustpilot-rating-text-copy">Excellent</div>
                                            <div class="text-block-1796-copy">4.6</div>
                                            <div class="score-text-copy">out of 5</div>
                                        </div>
                                        <div class="div-block-2310">
                                            <img src="/images/Trustpilot_Logo_2022.svg.webp" loading="lazy" sizes="(max-width: 2560px) 100vw, 2560px" srcset="/images/Trustpilot_Logo_2022.svg-p-500.png 500w, /images/Trustpilot_Logo_2022.svg-p-800.png 800w, /images/Trustpilot_Logo_2022.svg-p-1080.png 1080w, /images/Trustpilot_Logo_2022.svg.webp 2560w" alt="" class="trustpilot-rating-logo">
                                            <div class="trust-pilot-mobile-div-copy">
                                                <div class="trust-pilot-code-embed w-embed">
                                                    <!-- TrustBox widget - Pop-Up -->
                                                    <div class="trustpilot-widget" data-locale="en-US" data-template-id="5418015fb0d04a0c9cf721f2" data-businessunit-id="68b065d56ad677c356e83828" data-style-height="30px" data-style-width="100%" data-token="cef789bd-4856-4b49-82f4-7de3c7b5d12b" data-stars="1,2,3,4,5" data-review-languages="en">
                                                        <a href="https://www.trustpilot.com/review/newself.com" target="_blank" rel="noopener">Trustpilot</a>
                                                    </div>
                                                    <!-- End TrustBox widget -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a href="#" @click.prevent="active_el=2" class="button-178-copy w-button"><strong>Choose Your Plan </strong><span class="text-span-434">-&gt;</span></a>
                    </div>
                </div>
                <div class="step5_div-copy" v-if="active_el==2">
                    <div class="flow-step1-headers payplan-section">
                        <div class="checkout-flow-headers-copy choose-pay-plan-header-copy hide">Renew your plan below so<br>you don't miss a dose:</div>
                        <div class="div-block-2240 hide-flex">
                            <div class="text-block-1687">Not sure?</div>
                            <a href="#" class="link-block-47 hide w-inline-block">
                                <img loading="lazy" src="/images/icon_call.svg" alt="" class="image-379">
                                <div class="text-block-711">Talk with a Care Concierge</div>
                            </a>
                        </div>
                    </div>
                    <div class="checkout-choiceflex-div">
                        <div id="checkout-options" class="flow-payplan-div-copy">
                            <div class="checkout-form w-form">
                                <form id="email-form" name="email-form" data-name="Email Form" method="get">
                                    <div class="flow_payplan_select">
                                        <div class="pay-plan-top hide">
                                            <div class="text-block-1688-copy hide">Weight Loss</div>
                                            <a href="#" class="link-88-copy">Remove</a>
                                        </div>
                                        <div class="order-item-flex">
                                            <div class="div-block-2241">
                                                <div class="product-box-flex">
                                                    <div class="product-name-and-sub">
                                                        <div class="text-block-1690-copy">{{ displayProductName }}<span class="text-span-422">+</span></div>
                                                        <div class="text-block-1691">COMPOUNDED W/ {{ productKey === 'tirzepatide' ? 'B6' : 'B12' }}</div>
                                                    </div>
                                                </div>
                                                <div class="text-block-1693-copy">Meet with a provider to discuss your personalized care plan.</div>
                                            </div>
                                            <div class="order_img_div">
                                                <img src="/images/Semaglutide-Vial_1.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="/images/Semaglutide-Vial_1-p-500.webp 500w, /images/Semaglutide-Vial_1-p-800.webp 800w, /images/Semaglutide-Vial_1.webp 1080w" alt="">
                                            </div>
                                        </div>
                                        <div class="text-block-1696-copy">No refill hassles. Pay monthly - no interest, no credit checks or high-fees like Klarna</div>
                                        <label class="w-checkbox checkout_checkbox-field w-clearfix" @click="selectPlan(1)">
                                            <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': selectedPlan === 1 }"></div>
                                            <input type="checkbox" name="checkbox-3" id="checkbox-monthly" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1">
                                            <span class="checkout-checkbox-text-copy w-form-label" for="checkbox-monthly"><span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(plans[1].perMonth) }}</strong><span class="text-span-416"><strong><sup>{{ formatCents(plans[1].perMonth) }}</sup></strong></span></span><span class="text-span-417">/mo.</span><br></span>
                                            <div class="div-block-2242">
                                                <div class="text-block-1694-copy">Monthly Supply</div>
                                            </div>
                                        </label>
                                        <div class="text-block-1697-copy">Commit to a longer plan &amp; <span class="text-span-451">Save More.</span></div>
                                        <div class="plans-div">
                                            <label class="w-checkbox checkout_checkbox-field w-clearfix" @click="selectPlan(3)">
                                                <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': selectedPlan === 3 }"></div>
                                                <input type="checkbox" name="checkbox-3mo" id="checkbox-3mo" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1">
                                                <span class="checkout-checkbox-text-copy w-form-label" for="checkbox-3mo"><span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(plans[3].perMonth) }}</strong><span class="text-span-416"><strong><sup>{{ formatCents(plans[3].perMonth) }}</sup></strong></span></span><span class="text-span-417">/ mo. (3 mo plan)</span><br></span>
                                                <div class="div-block-2242">
                                                    <div class="text-block-1694-copy"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(plans[3].total) }}<sup class="superscript-9">{{ formatCents(plans[3].total) }}</sup></span> today</div>
                                                </div>
                                            </label>
                                            <label class="w-checkbox checkout_checkbox-field w-clearfix" @click="selectPlan(6)">
                                                <span class="plan-badge plan-badge--popular">Popular</span>
                                                <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': selectedPlan === 6 }"></div>
                                                <input type="checkbox" name="checkbox-6mo" id="checkbox-6mo" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1">
                                                <span class="checkout-checkbox-text-copy w-form-label" for="checkbox-6mo"><span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(plans[6].perMonth) }}</strong><span class="text-span-416"><strong><sup>{{ formatCents(plans[6].perMonth) }}</sup></strong></span></span><span class="text-span-417">/ mo. (6 mo plan)</span><br></span>
                                                <div class="div-block-2242">
                                                    <div class="text-block-1694-copy"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(plans[6].total) }}<sup class="superscript-9">{{ formatCents(plans[6].total) }}</sup></span> today</div>
                                                </div>
                                            </label>
                                            <label class="w-checkbox checkout_checkbox-field w-clearfix" @click="selectPlan(12)">
                                                <span class="plan-badge plan-badge--recommended">Recommended</span>
                                                <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': selectedPlan === 12 }"></div>
                                                <input type="checkbox" name="checkbox-12mo" id="checkbox-12mo" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1">
                                                <span class="checkout-checkbox-text-copy w-form-label" for="checkbox-12mo"><span class="price-amt" :class="{ 'price-loading': !pricesReady }"><strong>${{ formatDollars(plans[12].perMonth) }}</strong><span class="text-span-416"><strong><sup>{{ formatCents(plans[12].perMonth) }}</sup></strong></span></span><span class="text-span-417">/ mo. (12 mo plan)</span><br></span>
                                                <div class="div-block-2242">
                                                    <div class="text-block-1694-copy"><span class="price-amt" :class="{ 'price-loading': !pricesReady }">${{ formatDollars(plans[12].total) }}<sup class="superscript-9">{{ formatCents(plans[12].total) }}</sup></span> today</div>
                                                    <SummerSaleBadge />
                                                </div>
                                            </label>
                                        </div>
                                    </div>
                                </form>
                                <div class="w-form-done">
                                    <div>Thank you! Your submission has been received!</div>
                                </div>
                                <div class="w-form-fail">
                                    <div>Oops! Something went wrong while submitting the form.</div>
                                </div>
                            </div>
                        </div>
                        <div class="form-block-27 w-form">
                            <form id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" @submit.prevent="applyCoupon">
                                <div class="upgrade-coupon-div">
                                    <input v-model="couponCode" class="text-field-68 w-input" :class="{ 'coupon-error': couponError }" maxlength="256" name="field" data-name="Field" placeholder="Optional Coupon Code" type="text" id="field" :disabled="couponApplied">
                                    <a href="#" class="button-172 w-button" :class="{ 'coupon-applied': couponApplied }" @click.prevent="applyCoupon">{{ couponApplied ? 'Applied' : 'Apply' }}</a>
                                </div>
                            </form>
                            <div class="w-form-done">
                                <div>Thank you! Your submission has been received!</div>
                            </div>
                            <div class="w-form-fail">
                                <div>Oops! Something went wrong while submitting the form.</div>
                            </div>
                        </div>
                        <div class="checkout-button-div">
                            <div v-if="errorMessage" class="upgrade-error-message">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <circle cx="12" cy="12" r="10"/>
                                    <path d="M12 8v4M12 16h.01"/>
                                </svg>
                                <span>{{ errorMessage }}</span>
                            </div>
                            <div class="upgrade-checkout-button" @click="processUpgrade">
                                <div class="cart-icon-div-2-copy hide">
                                    <div class="code-embed-3-copy w-embed">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="auto" fill="currentColor" class="bi bi-cart3" viewBox="0 0 16 16">
                                            <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l.84 4.479 9.144-.459L13.89 4zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div>Upgrade Now </div>
                                <div class="button-price">- <span class="price-amt" :class="{ 'price-loading': !pricesReady }">{{ displayPrice }}</span></div>
                            </div>
                            <p class="paragraph-185-copy-copy">By clicking "Buy Now and Save" or checking out with Apple or Google Pay you agree to enroll in a 6-month program billed every 6 months, with automatic renewal and charges until canceled. You authorize recurring payments and confirm that you have read and agree to the <a href="https://newself.com/returns-and-refund" target="_blank" rel="noopener">Refund Policy</a>, <a href="https://newself.com/terms-of-use" target="_blank" rel="noopener">Terms and Conditions</a>, <a href="https://newself.com/terms-of-use" target="_blank" rel="noopener">Terms of Use</a>, <a href="https://newself.com/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>, <a href="https://newself.com/hipaa" target="_blank" rel="noopener">HIPAA Notice</a>, and <a href="https://newself.com/telehealth-consent" target="_blank" rel="noopener">Tele Health Consent</a>, and are at least 18 years of age.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
// Custom CSS additions for upgrade page (84 classes added in PR #17)
// Base webflow CSS is loaded globally via index.html
import '@/assets/css/upgrade-isolated.css'

export default {
    name: 'UpgradeCheckout',
    props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
    data() {
        return {
            selectedPlan: 12,
            couponCode: '',
            loading: false,
            correlationId: null,
            productName: '',
            productId: '',
            active_el: 1,
            couponApplied: false,
            couponError: false,
            couponValid: false,
            discount: 0,
            couponId: null,
            allPlans: [],
            // False until live plans load, gates the price skeleton to stop the
            // $0.00 placeholder flashing before /api/get-all-plans resolves.
            pricesReady: false,
            mobileMenuOpen: false,
            errorMessage: '',
        }
    },

    computed: {
        productKey() {
            // Map product name to pricing config key
            const name = this.productName.toLowerCase();
            if (name.includes('tirzepatide')) return 'tirzepatide';
            return 'semaglutide';
        },

        filteredPlans() {
            // Filter plans by productId and only include terms 1, 3, 6, 12
            return this.allPlans.filter(plan =>
                plan.product === this.productId &&
                [1, 3, 6, 12].includes(plan.terms) &&
                plan.is_active
            );
        },

        plans() {
            const result = {
                1: { perMonth: 0, total: 0, display: '$0.00', planId: null },
                3: { perMonth: 0, total: 0, display: '$0.00', planId: null },
                6: { perMonth: 0, total: 0, display: '$0.00', planId: null },
                12: { perMonth: 0, total: 0, display: '$0.00', planId: null }
            };

            this.filteredPlans.forEach(plan => {
                if (result[plan.terms]) {
                    result[plan.terms] = {
                        perMonth: plan.terms === 1 ? plan.price : (plan.price / plan.terms).toFixed(2),
                        total: plan.price,
                        display: `$${plan.price.toLocaleString('en-US', { minimumFractionDigits: 2 })}`,
                        planId: plan.id
                    };
                }
            });

            return result;
        },

        displayPrice() {
            const total = this.plans[this.selectedPlan]?.total || 0;
            const finalPrice = total - this.discount;
            return `$${finalPrice.toLocaleString('en-US', { minimumFractionDigits: 2 })}`;
        },

        displayProductName() {
            return this.productName || 'Semaglutide';
        }
    },

    mounted() {
        this.loadTrustPilotScript();
        this.getProductDetails();

    },

    methods: {
        formatDollars(value) {
            const num = parseFloat(value);
            return Math.floor(num).toLocaleString('en-US');
        },
        async validateCoupon() {
            if (this.couponApplied) return;
            this.couponError = false;
            try {
                const response = await this.$axios.post(`${this.baseUrl}/api/validate-coupon`, {
                    coupon: this.couponCode,
                    payment_terms: this.selectedPlan
                });

                if (response.data.status === 'success') {
                    this.couponValid = true;
                    this.couponApplied = true;
                    this.couponId = response.data.coupon_id;
                    if (response.data.c_type === 2) {
                        // Calculate percentage-based discount
                        const planAmount = this.getTotalOrderAmount();
                        const discountPercentage = response.data.c_val;
                        this.discount = parseFloat(((planAmount * discountPercentage) / 100).toFixed(2));
                    } else {
                        this.discount = response.data.c_val;
                    }

                } else {
                    this.couponValid = false;
                    this.couponError = true;
                }
            } catch (error) {
                this.couponValid = false;
                this.couponError = true;
            }
        },

        getTotalOrderAmount() {
            return this.plans[this.selectedPlan]?.total || 0;
        },
        formatCents(value) {
            const num = parseFloat(value);
            const cents = Math.round((num % 1) * 100);
            return cents.toString().padStart(2, '0');
        },

        selectPlan(plan) {
            this.selectedPlan = plan
        },

        applyCoupon() {
            if (!this.couponCode.trim()) return;
            this.validateCoupon();
        },

        async processUpgrade() {
            if (this.loading) return; // prevent double-charge: div @click has no native disabled
            this.loading = true;
            // One UUID per payment attempt - anchors the backend's Stripe idempotency key
            // so a duplicate of this same attempt can't create a second charge.
            this.correlationId = crypto.randomUUID();
            this.errorMessage = '';
            try {
                const selectedPlanData = this.plans[this.selectedPlan];
                const total = selectedPlanData?.total || 0;
                const amount = total - this.discount;
                const response = await this.$axios.post(`${this.baseUrl}/api/upgrade-plan`, {
                    productId: this.productId,
                    planId: selectedPlanData?.planId,
                    terms: this.selectedPlan,
                    couponId: this.couponId,
                    amount: amount
                }, {
                    headers: { 'X-Correlation-Id': this.correlationId }
                });

                if (response.data.success) {
                    // Success: keep loading = true so the overlay/button stay
                    // disabled through the redirect. Re-enabling before navigation
                    // lets a second click fire a duplicate charge.
                    this.$router.push('/home');
                } else {
                    // Genuine failure: re-enable so the user can retry.
                    this.errorMessage = response.data.message || 'Upgrade failed. Please try again.';
                    this.loading = false;
                }
            } catch (error) {
                console.error('Upgrade failed:', error);
                this.errorMessage = error.response?.data?.message || 'Payment failed. Please try again.';
                this.loading = false;
            }
        },
        async getProductDetails() {
            this.loading = true;
            try {
                const response = await this.$axios.get(`${this.baseUrl}/api/get-current-product`);
                if (response.data.success) {
                    this.productId = response.data.product;
                    this.productName = response.data.productName;
                    // Fetch plans after getting product details
                    await this.getAllPlans();
                }
            } catch (error) {
                console.error('Failed to get product details:', error);
            } finally {
                this.loading = false;
            }
        },

        async getAllPlans() {
            try {
                const response = await this.$axios.get(`${this.baseUrl}/api/get-all-plans`);
                if (response.data.status === 'success') {
                    this.allPlans = response.data.plans;
                    this.pricesReady = true;
                }
            } catch (error) {
                console.error('Failed to get plans:', error);
            }
        },
        loadTrustPilotScript() {
            if (!document.querySelector('script[src*="trustpilot"]')) {
                const script = document.createElement('script')
                script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
                script.async = true
                document.head.appendChild(script)
            }
        }
    }
}
</script>

<style scoped>

/* Price loading skeleton — hides $0.00 placeholder until live plan prices load */
.price-amt { display: inline-block; }
.price-loading {
    color: transparent !important;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    min-width: 3ch;
}
.price-loading::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, #e9e9e9 25%, #f5f5f5 50%, #e9e9e9 75%);
    background-size: 200% 100%;
    animation: price-shimmer 1.1s ease-in-out infinite;
}
@keyframes price-shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}

/* Payment error feedback */
.upgrade-error-message {
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 16px;
    color: #dc2626;
    font-size: 14px;
    font-weight: 500;
}
.upgrade-error-message svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}
[data-theme="dark"] .upgrade-error-message {
    background-color: #450a0a;
    border-color: #7f1d1d;
    color: #f87171;
}

/* Plan badges (Popular / Recommended) */
.upgrade-checkout-page .plan-badge {
    position: absolute;
    top: -13px;
    left: 18px;
    z-index: 2;
    background-color: #d7fff0;
    color: #000;
    font-family: var(--satoshi, 'Satoshi', sans-serif);
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
    padding: 6px 11px;
    border-radius: 999px;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    white-space: nowrap;
    pointer-events: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}


/* Plan card spacing/padding — bigger, more uniform */
.upgrade-checkout-page .checkout_checkbox-field {
    padding: 20px 16px;
    margin-bottom: 14px;
}

.upgrade-checkout-page .plans-div .checkout_checkbox-field:last-child {
    margin-bottom: 0;
}

/* Ensure the 12-month card has room for the inline savings badge */
.upgrade-checkout-page .checkout_checkbox-field .div-block-2242 {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
}

.upgrade-checkout-page .text-block-1801,
.upgrade-checkout-page .text-span-450 {
    font-weight: 400;
}

.upgrade-checkout-page .text-block-1801 {
    white-space: nowrap;
}

.upgrade-checkout-page .text-block-1800 {
    font-weight: 700;
}

.upgrade-checkout-page .promo-box {
    text-align: center;
    margin: 0 auto;
}

.upgrade-checkout-page .promo-div {
    display: flex;
    justify-content: center;
}

.upgrade-checkout-page .text-block-775 {
    width: 100%;
    text-align: center;
}

.upgrade-checkout-page .trustpilot-rating-text-copy,
.upgrade-checkout-page .text-block-1796-copy {
    font-weight: 600;
}

.upgrade-checkout-page .text-block-1693-copy,
.upgrade-checkout-page .text-block-1694-copy,
.upgrade-checkout-page .text-block-1696-copy,
.upgrade-checkout-page .text-block-1697-copy {
    font-weight: 500;
}

.upgrade-checkout-page .coupon-applied {
    background-color: #4CAF50;
    pointer-events: none;
}

.upgrade-checkout-page .coupon-error {
    border-color: #f44336;
}

/* Mobile menu toggle */
@media screen and (max-width: 991px) {
    .upgrade-checkout-page .nav-menu-4 {
        display: flex;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background-color: #f6f6f6;
        padding: 0 20px;
        flex-direction: column;
        align-items: center;
        z-index: 100;
        overflow: hidden;
        max-height: 0;
        transition: max-height 0.4s ease, padding 0.4s ease;
    }

    .upgrade-checkout-page .nav-menu-4.w--nav-menu-open {
        max-height: 200px;
        padding: 15px 20px;
    }

    .upgrade-checkout-page .menu-button-4 {
        display: flex;
    }

    .upgrade-checkout-page .navbar-3 {
        position: relative;
    }

    .upgrade-checkout-page .brand-4,
    .upgrade-checkout-page .brand-4 img,
    .upgrade-checkout-page .nav-logo.weight {
        display: block !important;
        visibility: visible !important;
    }
}

@media screen and (min-width: 992px) {
    .upgrade-checkout-page .menu-button-4 {
        display: none;
    }
}
</style>
